import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';

import type {
    IValidateCodeRequest,
    IValidateCodeResponse,
    ISendFormPresaleRequest,
    ISendFormDefaultRequest,
    ISendFormResponse,
    IRequestCodeRequest,
    IRequestCodeResponse,
    IRequestCodeBody,
} from '../models';

const HEADERS = {
    Authorization: process.env.ALFALEASING_CLAIMS_SITE_AUTH,
};
const HOST = process.env.ALFALEASING_CLAIMS_SITE_HOST;

export const sendForm = async (
    payload: ISendFormPresaleRequest | ISendFormDefaultRequest,
    isPresaleRequest: boolean,
    token: string | null
) => {
    const url = isPresaleRequest
        ? `${HOST}/alfa-leasing-claims-site-api/v1/presale-requests/step-by-step`
        : `${HOST}/alfa-leasing-claims-site-api/v1/requests`;

    const request: AxiosRequestConfig = {
        method: 'POST',
        url,
        headers: HEADERS,
        params: {
            token,
        },
        data: payload,
    };

    const { data }: AxiosResponse<ISendFormResponse> = await axios(request);

    return data;
};

export const requestCode = async (params: IRequestCodeRequest, body: IRequestCodeBody) => {
    const request: AxiosRequestConfig = {
        method: 'POST',
        url: `${HOST}/alfa-leasing-claims-site-api/v1/send-sms`,
        headers: HEADERS,
        params,
        data: body,
    };

    const { data }: AxiosResponse<IRequestCodeResponse> = await axios(request);

    return data;
};

export const validateCode = async (payload: IValidateCodeRequest) => {
    const request: AxiosRequestConfig = {
        method: 'POST',
        url: `${HOST}/alfa-leasing-claims-site-api/v1/check-otp`,
        headers: HEADERS,
        data: payload,
    };

    const { data }: AxiosResponse<IValidateCodeResponse> = await axios(request);

    return data;
};
